export const sortTypes = {
  ascending: 'ascending',
  descending: 'descending',
  manual: 'manual',
  author: 'author',
  date: 'date',
}

export const itemTypes = {
  course: 'Course',
  flashcardCategory: 'FlashcardCategory',
  flashcardSet: 'FlashcardSet',
  folder: 'Folder',
  lesson: 'Lesson',
  post: 'Post',
  video: 'Video',
}
